import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext(null);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

let toastManager = {
  show: () => console.warn('ToastProvider not initialized')
};

let toastCounter = 0;

export const showGlobalToast = (message, type = 'info', duration = 3000) => {
  toastManager.show(message, type, duration);
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = `${Date.now()}-${toastCounter++}`;
    setToasts((prev) => [...prev, { id, message, type, duration }]);
  }, []);

  toastManager.show = showToast;

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showSuccessToast = useCallback((message, duration = 3000) => {
    showToast(message, 'success', duration);
  }, [showToast]);

  const showErrorToast = useCallback((message, duration = 3000) => {
    showToast(message, 'error', duration);
  }, [showToast]);

  const showInfoToast = useCallback((message, duration = 3000) => {
    showToast(message, 'info', duration);
  }, [showToast]);

  return (
    <ToastContext.Provider value={{ showToast, showSuccessToast, showErrorToast, showInfoToast }}>
      {children}
      <div style={{ zIndex: 9999999 }} className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 flex flex-col gap-2.5 w-auto max-w-sm sm:max-w-md pointer-events-none">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
